import { ArrowIcon } from './arrow';
import CheckIcon from './check';
import CloseIcon from './close';
import { Clothing } from './clothing';
import { Footwear } from './footwear';
import { GraduationCapIcon } from './graduation-cap-icon';
import { MinusIcon } from './minus';
import { PlusIcon } from './plus';

export { ArrowIcon, CheckIcon, CloseIcon, Clothing, Footwear, GraduationCapIcon, MinusIcon, PlusIcon };
